export function addSignaturesAccountantAndAuditor ({doc, positionY, leftLineMargin, longLine, AccountantName, AccountantAdditional, AuditorName, AuditorAdditional, AuditorShow = true}) {
    const y_linea = positionY; // La coordenada Y donde se dibujará la línea
    const y_texto = y_linea + 5; // La coordenada Y donde irá el texto (ligeramente debajo de la línea)
    const y_texto_adicional = y_texto + 4; // La coordenada Y para el segundo texto
    const y_texto_cargo = AuditorAdditional ? y_texto_adicional + 4 : y_texto + 4; // La coordenada Y para el tercer texto
    // const ancho_pagina = doc.internal.pageSize.getWidth();

    // Coordenadas X para las dos secciones:
    const margen_linea_izq = leftLineMargin; // Margen izquierdo donde comienza la línea
    const longitud_linea = longLine; // Longitud de cada línea

    // --- Sección Izquierda (Contador) ---
    const x_inicio_izq = margen_linea_izq;
    const x_fin_izq = x_inicio_izq + longitud_linea;

    // Dibuja la línea divisoria izquierda
    doc.line(x_inicio_izq, y_linea, x_fin_izq, y_linea);

    // Añade el texto "Contador nombre" centrado en su sección
    const x_centro_izq = x_inicio_izq + longitud_linea / 2;
    doc.text(`${AccountantName ?? 'Contador'}`, x_centro_izq, y_texto, { align: "center" });

    doc.text(`${AccountantAdditional ?? ''}`, x_centro_izq, y_texto_adicional, { align: "center" });
    doc.text(`${AccountantName ? 'Contador' : ''}`, x_centro_izq, y_texto_cargo, { align: "center" });

    // --- Sección Derecha (Firma) ---
    // Calcula las coordenadas para la derecha, dejando un espacio en el centro.
    const espacio_central = 20; // Espacio entre las dos secciones
    const x_inicio_der = x_fin_izq + espacio_central;
    const x_fin_der = x_inicio_der + longitud_linea;
    if(AuditorShow){
    // Dibuja la línea divisoria derecha
    doc.line(x_inicio_der, y_linea, x_fin_der, y_linea);

    const x_centro_der = x_inicio_der + longitud_linea / 2;
    doc.text(`${AuditorName ?? 'Auditor'}`, x_centro_der, y_texto, { align: "center" });
    doc.text(`${AuditorAdditional ?? ''}`, x_centro_der, y_texto_adicional, { align: "center" });
    doc.text(`${AuditorName ? 'Auditor' : ''}`, x_centro_der, y_texto_cargo, { align: "center" });
    }
}